import { useEffect, useState } from 'react';

import moment from 'moment';

import RadarChart from 'components/RadarChart';

import AthleticAbility from './AthleticAbility';

const AthleticAbilityIcon_1 = require('assets/resources/AthleticAbilityIcon_1.svg').default;
const NoResultReport = require('assets/resources/NoResultReport.svg').default;

const ResultReport = (props) => {
  const { dataReport, dataAnalysis } = props;
  const [analysis_content, setAnalysis_content] = useState(null);
  const [integrated_analysis_content, setIntegrated_analysis_content] = useState(null);

  useEffect(() => {
    setAnalysis_content(dataAnalysis?.analysis_content || null);
    setIntegrated_analysis_content(dataAnalysis?.integrated_analysis_content || null);
  }, [dataAnalysis]);

  return (
    <div className="w-full">
      {analysis_content?.child_id && (
        <>
          <div className="flex items-center space-x-6 text-black/85 text-sm mb-8">
            <span>
              {'生成日'}：{moment(dataReport?.created_at).format('YYYY/MM/DD')}
            </span>
          </div>

          <div className="mt-8">
            <h1 className="text-xl font-bold text-black-102">SDQ結果</h1>
            <p className="text-sm text-secondary-354">※この結果は発達遅延・障害の診断をするものではありません。</p>
            <div className="mt-2 py-6 px-8 border border-white-714/50 rounded-lg">
              <div className="w-full h-50">
                <RadarChart data={analysis_content?.analysis_results?.score_summary || {}} />
              </div>
              <div
                className="mt-6 text-black-102"
                dangerouslySetInnerHTML={{ __html: analysis_content?.analysis_results?.evaluation?.summary ?? '' }}
              />
            </div>
          </div>

          <div className="mt-8">
            <h1 className="text-xl font-bold text-black-102">運動能力</h1>
            <div className="mt-2 py-6 px-8 border border-white-714/50 rounded-lg">
              <AthleticAbility data={integrated_analysis_content} />
              {integrated_analysis_content?.analysis_results?.comments && (
                <>
                  <div className="flex items-center gap-1 mt-6">
                    <img src={AthleticAbilityIcon_1} alt="AthleticAbilityIcon_1" width={20} height={20} />
                    <p className="font-bold">の部分に対するコメント</p>
                  </div>
                  <div
                    className="mt-2 text-sm text-black-102"
                    dangerouslySetInnerHTML={{ __html: integrated_analysis_content?.analysis_results?.comments ?? '' }}
                  ></div>
                </>
              )}
            </div>
          </div>
          {analysis_content?.analysis_results?.child_behavior_issues &&
            !Object.keys(analysis_content?.analysis_results?.child_behavior_issues).some((key) => key.length === 0) && (
              <div className="mt-8">
                <h1 className="text-xl font-bold text-black-102">気になる行動対処法</h1>
                {analysis_content?.analysis_results?.child_behavior_issues?.sdq_survey.map((sdq, indexSDQ) => (
                  <div key={indexSDQ} className="mt-2 py-6 px-8 border border-white-714/50 rounded-lg">
                    <div className="flex justify-between items-center gap-1">
                      <div className="mx-auto">
                        <p className="font-bold">「{sdq.subscale}」の気になる場面例</p>
                        <div className="w-full h-0.25 mt-2 bg-gray-489"></div>
                      </div>
                    </div>
                    <div className="mt-4 text-sm text-black-102">
                      <ul className="list-disc pl-5">
                        {sdq.issues.map((item, index) => (
                          <li key={index} className="mt-4">
                            「{item}」
                          </li>
                        ))}
                        {indexSDQ === analysis_content?.analysis_results?.child_behavior_issues?.sdq_survey.length - 1 &&
                          analysis_content?.analysis_results?.child_behavior_issues?.sdq_mchat.map((item, index) => (
                            <li key={index} className="mt-4">
                              「{item}」
                            </li>
                          ))}
                        {indexSDQ === analysis_content?.analysis_results?.child_behavior_issues?.sdq_survey.length - 1 &&
                          analysis_content?.analysis_results?.child_behavior_issues?.sdq_dipole.map((item, index) => (
                            <li key={index} className="mt-4">
                              「{item}」
                            </li>
                          ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            )}
        </>
      )}
      {!analysis_content?.child_id && (
        <div className="no-result-report bg-white w-full h-81.5 flex justify-center items-center">
          <img src={NoResultReport} alt="NoResultReport" />
        </div>
      )}
    </div>
  );
};

export default ResultReport;
